import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ElapsedTimeService {
  /*
    It accepts a key to record the initial timestamp (start).
    If the specific eventName is generic and used on multiple location in the same page
    would make sense to avoid the usage of the eventName when using ElapsedTimeService.
    A suggestion may be to create a composite key like eventName#type.
    i.e.:
    `action_didactic_material_use` is used on different type of material.
    If only one material is available on that page it make sense to use
    `start(action_didactic_material_use)`, if multiple materials coexist in the same page
    something like `start(action_didactic_material_use#summary)` and
    `start(action_didactic_material_use#flashcards)` can be valuable options.
   */

  private elapsedTimes = new Map<string, number>();

  public start(key: string): void {
    if (!this.elapsedTimes.has(key)) {
      console.warn(`Elapsed time with key ${key} already started. Overwriting it...`);
    }
    this.elapsedTimes.set(key, Date.now());
  }

  public stop(key: string): number | null {
    const start = this.elapsedTimes.get(key);
    if (!start) {
      return null;
    }
    const elapsed = (Date.now() - start) / 1000;
    this.elapsedTimes.delete(key);
    return elapsed;
  }
}
